/**
 * v-isInnerAdmin 是否内部管理员
 * Copyright (c) 2019 ruoyi
 */

import useUserStore from '@/store/modules/user'

export default {
    mounted(el,binding, vnode) {
        const { value } = binding
        // 跳出
        if (value && value.disabled) {
            return
        }
        const inner_admin = "inner";
        const roles = useUserStore().roles
        console.log(useUserStore().roles)
        const isInnerAdmin = !!roles.find(role => role === inner_admin)
        if (!isInnerAdmin) {
            el.parentNode && el.parentNode.removeChild(el)
        }

    }
}
